/**
 * @author Jersson Stiven Morales Alza
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart stock',
  'sidebar.tiposClientes': 'Types  Customers',
  'tiposClientes.agregarTypes Customers': 'Create Types  Customers',
  'tiposClientes.modificarTypes Customers': 'Edit Types  Customers',
  'tiposClientes.eliminarTypes Customers': 'Delete Types  Customers',
  'tiposClientes.tipoClienteId': 'Client Type Id',
  'tiposClientes.empresaId': ' Company Id',
  'tiposClientes.tipoClienteDescripcion': ' Client Type Description',
  'tiposClientes.types Customers': 'Types  Customers',
  'tiposClientes.verTypes Customers': 'View Types  Customers',
};
